<pr-form (onSubmit)="submit()" [title]="title" [formGroup]="form">
  <pr-input-radio
    label="Genre"
    formControlName="gender"
    [options]="[
      { value: 'M', label: 'Garçon', icon: 'male' },
      { value: 'F', label: 'Fille', icon: 'female' },
    ]"
  >
  </pr-input-radio>
  <pr-input [label]="'Prénom'" [derrors]="derrors"
    ><input formControlName="firstName" type="text"
  /></pr-input>
  <pr-input [label]="'Nom'" [derrors]="derrors"
    ><input formControlName="lastName" type="text"
  /></pr-input>

  <pr-input-date
    label="Date de naissance"
    formControlName="birthDate"
    [derrors]="derrors"
  ></pr-input-date>

  <pr-input [label]="'Ville de naissance'" [derrors]="derrors"
    ><input formControlName="birthCity" type="text"
  /></pr-input>

  <pr-input [label]="'CP de naissance'" [derrors]="derrors"
    ><input formControlName="birthZipCode" type="text"
  /></pr-input>

  <pr-input label="Département de naissance" [derrors]="derrors">
    <mat-select formControlName="birthLocation">
      <mat-select-trigger [style]="{ display: 'flex' }">
        {{
          _.find(departments, ['id', form.get('birthLocation')?.value])?.value
        }}
      </mat-select-trigger>
      @for (department of departments; track department) {
        <mat-option [value]="department.id">
          {{ department.id }} - {{ department.value }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input label="Pays de naissance" [derrors]="derrors">
    <mat-select formControlName="birthCountry">
      <mat-select-trigger [style]="{ display: 'flex' }">
        <!-- <pr-icon [name]="'fs-' + _.find(countries, ['value', form?.get('nationality')?.value])?.id.toLowerCase()" class="mrs">
      </pr-icon> -->
        {{ _.find(countries, ['id', form.get('birthCountry')?.value])?.value }}
      </mat-select-trigger>
      @for (country of countries; track country) {
        <mat-option [value]="country.id">
          <!-- <pr-icon [name]="'fs-' + country.id.toLowerCase()"></pr-icon> -->
          {{ country.value }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input label="Nationalité" [derrors]="derrors">
    <mat-select formControlName="nationality">
      <mat-select-trigger [style]="{ display: 'flex' }">
        <!-- <pr-icon [name]="'fs-' + _.find(countries, ['value', form?.get('nationality')?.value])?.id.toLowerCase()" class="mrs">
    </pr-icon> -->
        {{ _.find(countries, ['id', form.get('nationality')?.value])?.value }}
      </mat-select-trigger>
      @for (country of countries; track country) {
        <mat-option [value]="country.id">
          <!-- <pr-icon [name]="'fs-' + country.id.toLowerCase()"></pr-icon> -->
          {{ country.value }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input label="Résidence fiscale" [derrors]="derrors">
    <mat-select formControlName="taxResidence">
      <mat-select-trigger [style]="{ display: 'flex' }">
        <!-- <pr-icon [name]="'fs-' + _.find(countries, ['value', form?.get('nationality')?.value])?.id.toLowerCase()" class="mrs">
    </pr-icon> -->
        {{ _.find(countries, ['id', form.get('taxResidence')?.value])?.value }}
      </mat-select-trigger>
      @for (country of countries; track country) {
        <mat-option [value]="country.id">
          <!-- <pr-icon [name]="'fs-' + country.id.toLowerCase()"></pr-icon> -->
          {{ country.value }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input label="Capacité juridique" [derrors]="derrors">
    <mat-select formControlName="legalCapacity">
      @for (legalCapacity of legalCapacities; track legalCapacity) {
        <mat-option [value]="legalCapacity.id">
          {{ legalCapacity.value | translate }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input label="Enfant issu de :" [derrors]="derrors">
    <mat-select formControlName="childFiliation">
      @for (childFiliation of childFiliations; track childFiliation) {
        <mat-option [value]="childFiliation.id">
          {{ childFiliation.value | translate }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input-radio
    formControlName="inCharge"
    label="A charge (foyer fiscal)"
  ></pr-input-radio>
  <pr-input-radio
    formControlName="isHandicapped"
    label="Handicapé"
  ></pr-input-radio>
</pr-form>
